// extracted by mini-css-extract-plugin
export default {"root":"UploadImage_root__VznaQ","image":"UploadImage_image__hmGJl","fakeImage":"UploadImage_fakeImage__IbrTI"};